<template>
    <div class="common-fission-share">
        <div class="channels" v-if="displayChannels && displayChannels.length">
            <div class="list">
                <div class="item" v-for="config in displayChannels" :key="config.channel">
                    <a class="box" @click="handleShare(config.channel)">
                        <div :class="['icon', config.channel]"></div>
                        <div class="name">
                            {{ lang.names[config.channel] }}
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script >
import { computed } from 'vue-demi';
import { languageMap } from '../common/lang';
import { Language } from '../type';
const __sfc_main = {};
__sfc_main.props = {
  // 语种
  language: {
    type: String,
    default: Language.EN
  },
  channelConfigs: {
    type: Array,
    default: () => []
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  // 模拟多语言对象
  const lang = computed(() => ({
    ...languageMap[props.language]
  }));

  // 渠道排序
  const displayChannels = computed(() => {
    // 使用 Map 根据渠道名称去重，保留第一个出现的渠道配置
    const seen = new Map();
    return props.channelConfigs.filter(config => {
      if (!seen.has(config.channel)) {
        seen.set(config.channel, true);
        return true;
      }
      return false;
    });
  });
  const emit = __ctx.emit;
  const handleShare = channel => {
    emit('handle-share', channel);
  };
  return {
    lang,
    displayChannels,
    handleShare
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.common-fission-share {
    height: auto !important;
    width: 100%;

    .channels {
        padding: 0.5rem 0;
        .label {
            padding: 0 0.4rem;
            margin-bottom: 0.28rem;
            font-size: 0.36rem;
            color: #262626;
        }
        .list {
            padding: 0 0.4rem;
            margin: 0 0.25rem;
            display: flex;
            overflow-x: auto;
            /* 适用于Webkit浏览器 (Chrome, Safari) */
            -webkit-overflow-scrolling: touch; /* 平滑滚动 */
            /* 适用于Firefox */
            scrollbar-width: none; /* 隐藏滚动条 */
            /* 适用于Internet Explorer 10+ */
            -ms-overflow-style: none; /* 隐藏滚动条 */
            &::-webkit-scrollbar {
                display: none; /* 隐藏滚动条 */
            }
            .item {
                display: inline-block;
                margin: 0 0.4rem;
                &:nth-of-type(1) {
                    margin-left: 0.05rem;
                }
                &:nth-last-of-type(1) {
                    margin-right: 0.05rem;
                }
                .box {
                    display: block;
                    position: relative;
                    padding-bottom: 0.52rem;
                    cursor: pointer;
                }
                .icon {
                    width: 0.84rem;
                    height: 0.84rem;
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                    &.system {
                        background-image: url('../assets/images/system.svg');
                    }
                    &.reddit {
                        background-image: url('../assets/images/reddit.svg');
                    }
                    &.facebook {
                        background-image: url('../assets/images/facebook.svg');
                    }
                    &.telegram {
                        background-image: url('../assets/images/telegram.svg');
                    }
                    &.xiaohongshu {
                        background-image: url('../assets/images/xiaohongshu.svg');
                    }
                    &.twitter {
                        background-image: url('../assets/images/twitter.svg');
                    }
                    &.instagram {
                        background-image: url('../assets/images/instagram.svg');
                    }
                    &.wxFriend {
                        background-image: url('../assets/images/wechat.svg');
                    }
                    &.wxTimeline {
                        background-image: url('../assets/images/wechatMoments.svg');
                    }
                    &.whatsapp {
                        background-image: url('../assets/images/whatsapp.svg');
                    }
                    &.copy {
                        background-image: url('../assets/images/copy.svg');
                    }
                }
                .name {
                    position: absolute;
                    left: 50%;
                    bottom: 0;
                    transform: translateX(-50%);
                    font-size: 0.2rem;
                    color: #0f1112;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>
